'use strict';
import $ from 'jquery';

export default class DefaultMarketoForm {
    constructor() {
        if ($('.form [data-marketo-form]').length) {
            $('.form [data-marketo-form]').each(function () {
                let $form = $(this);
                $form.on('submitSuccess', function (values, followUpUrl) {
                    // Get the form's jQuery element and hide it
                    $form.parents('.ontinue-block').addClass('form-complete');
                    // Return false to prevent the submission handler from taking the lead to the follow up url
                    return false;
                });
            });
        }
    }
}